import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, FieldArray, reduxForm } from "redux-form";
import AppWrapper from "../../Common/AppWrapper/index.jsx";
import { CellAndGeneTherapySequence } from "./CellAndGeneTherapySequence.jsx";
import { CellAndGeneTherapyForm } from "./CellAndGeneTherapyForm";
import * as assayActions from "../../../actions/assays.js";
import * as config from "../../../app.config";
import CircularProgress from "@material-ui/core/CircularProgress";
import { RenderSelect } from "../../Common/InputComponents/Inputs.jsx";
import { tooltipVectorBackBone } from "../../Common/Misc/Tooltips";
import { requiredVectorBackbone } from "../../../util/validations.js";
import * as clientValidations from "../../../i18n/en/client-side-validation-errors.json";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import _ from "underscore";

import CellAndGeneTherapyDescription from "./CellAndGeneTherapy-Description.jsx";

import "../AssayCreate.scss";

const styles = (theme) => ({
  progress: {
    marginLeft: theme.spacing(2),
  },
});

export class CellAndGeneTherapyComponent extends React.Component {
  static propTypes = {
    formObj: PropTypes.object,
    handleSubmit: PropTypes.func,
    pristine: PropTypes.bool,
    actions: PropTypes.object,
  };

  componentWillUnmount() {
    const { actions } = this.props;
    actions.clearMessage();
  }
  onSubmit = (values, dispatch) => {
    return dispatch(assayActions.processGetNewAssays(values));
  };

  render() {
    const {
      formObj,
      classes,
      handleSubmit,
      pristine,
      submitting,
      validatedAssayDetails,
    } = this.props;

    const btnSubmitClass = classNames({
      "btn-submit float-right": !submitting,
      "btn-submit float-right btn-submitting": submitting,
    });

    const handleNeedsGoi = (props, val) => {
      const { formObj, reset, change } = this.props;
      if (val === "null" && !formObj.values.cellAndGeneTherapyForm.length) {
        reset();
        change("universalAssay", val);
      }
    };

    return (
      <div id="cellandgenetherapy-form">
        <div className="row">
          <div className="col-6">
            <div className="vba-dropdown">
              <Field
                name="universalAssay"
                className="form-control"
                component={RenderSelect}
                label="Vector Backbone Assays"
                validate={[requiredVectorBackbone]}
                tooltip={tooltipVectorBackBone}
                onChange={handleNeedsGoi}
              >
                {config.UNIVERSAL_ASSAY_OPTIONS.map((option) => {
                  return (
                    <option key={option.value} value={option.value}>
                      {option.name}
                    </option>
                  );
                })}
              </Field>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <hr />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div className="larger-label">Gene of Interest Assays</div>
          </div>
        </div>

        <FieldArray
          name="cellAndGeneTherapyForm"
          custom={this.props}
          component={CellAndGeneTherapyForm}
        />
        <div className="row">
          <div className="col">
            <button
              type="button"
              className={btnSubmitClass}
              disabled={
                (pristine || submitting) && _.isEmpty(validatedAssayDetails)
              }
              onClick={handleSubmit(this.onSubmit.bind(this))}
            >
              {!submitting ? "SUBMIT" : "SUBMITTING"}
              {submitting && (
                <CircularProgress
                  className={classes.progress}
                  size={20}
                  thickness={4}
                />
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const epochDate = new Date().getTime();

const stateToProps = (state) => ({
  formObj: state.form["frmCellAndGeneTherapy"],
  validatedAssayDetails:
    (state.assays &&
      state.assays.validatedAssayDetails &&
      state.assays.validatedAssayDetails.data) ||
    {},
  initialValues: {
    applicationType: "GeneTherapy",
    universalAssay: "null",
    cellAndGeneTherapyForm: [
      {
        targetby: "DnaSequence",
        assayFormat: "SingleTube",
        cellandgenetherapysequence: {
          assayTargetName: "",
          fluorophores: "FAM",
          created_at: epochDate,
        },
      },
    ],
  },
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});

const onSubmit = (values, dispatch) => {
  dispatch(assayActions.processGetNewAssays(values));
};
const validteMultipleFields = (values) => {
  const error = {};

  if (
    values &&
    values.universalAssay === "null" &&
    _.isEmpty(values.cellAndGeneTherapyForm)
  ) {
    error.universalAssay =
      clientValidations &&
      clientValidations.error &&
      clientValidations.error.cellAndGeneTherapy &&
      clientValidations.error.cellAndGeneTherapy.emptyInputAndSelection;
  }

  return error;
};

CellAndGeneTherapyComponent = reduxForm({
  form: "frmCellAndGeneTherapy",
  enableReinitialize: true,
  validate: validteMultipleFields,
})(CellAndGeneTherapyComponent);

CellAndGeneTherapyComponent = withStyles(styles)(CellAndGeneTherapyComponent);

CellAndGeneTherapyComponent = connect(
  stateToProps,
  dispatchToProps
)(CellAndGeneTherapyComponent);

const CellAndGeneTherapy = () => {
  return (
    <AppWrapper
      id="cellandgenetherapy"
      pageTitle="Cell and Gene Therapy"
      pageKeywords="Cell and Gene Therapy, design engine, custom assays"
      pageDescription="The Cell and Gene Therapy Design Engine enables you to quickly create custom ddPCR optimized assays for your target Gene of Interest or pick from a list of predesigned Vector Backbone Assays."
    >
      <div id="bg">
        <div id="bg-inner"></div>
      </div>
      <div className="container main-content">
        <div className="hero">
          <h2 className="h4">ASSAY DESIGN ENGINE</h2>
          <h1>Cell and Gene Therapy</h1>
        </div>
        <CellAndGeneTherapyComponent />
        <CellAndGeneTherapyDescription />
      </div>
    </AppWrapper>
  );
};

export default CellAndGeneTherapy;
